
(function () {
    function updateEditOptionsButtons() {
        const cartItems = document.querySelectorAll('.cart-item__details');
        
        cartItems.forEach(item => {
            const productNameElement = item.querySelector('a.cart-item__name span');
            
            if (!productNameElement) return;
            
            const productNameElementInnerHtml = productNameElement.innerHTML;
            const editOptionsButton = item.querySelector('.tpo_open-modal-button.tpo_edit-option-modal');
            
            if (!editOptionsButton) return;
            
            const productName = productNameElement.textContent.trim();
            
            if (productNameElementInnerHtml === "Custom Size Products") {
                console.log('editOptionsButton:', editOptionsButton.innerHTML);
            } else {
                editOptionsButton.style.display = 'none';
            }
        });
    }
    
    const footer = () => {
        setTimeout(updateEditOptionsButtons, 500);
    }

    document.addEventListener('DOMContentLoaded', footer);
    document.addEventListener('shopify:section:load', footer);
    footer();
})();